module.exports = __webpack_public_path__ + "img/27-green.704b3e82.svg";